import React from 'react'
// @ts-ignore no types
import { Button, Icon, Text, constants, hooks } from '@adc/ui-adc'
import classnames from 'classnames/bind'
// @ts-ignore no types
import cls from './styles.scss'

const cx = classnames.bind(cls)
const { ColorNames } = constants

const PATH_COLORS = {
  purple: { fill: ColorNames.Purple, dark: ColorNames.PurpleDark },
  success: { fill: ColorNames.Success, dark: ColorNames.SuccessDark },
}

export interface PathOptionButtonProps {
  title: string
  subtitle: string
  iconName: string
  color: 'purple' | 'success'
  onClick: () => void
  elmId: string
  selected?: boolean
  variant?: 'default' | 'modal'
}

// Selectable path card for the Dual-Track PDP. Fill + theming come from the DS
// Button (secondary + semantic color + isSelected); only the card layout and
// icon badge are styled locally.
const PathOptionButton = ({
  title,
  subtitle,
  iconName,
  color,
  onClick,
  elmId,
  selected = false,
  variant = 'default',
}: PathOptionButtonProps) => {
  // Modal title is 16px on the full modal, 14px on the mobile slide-up sheet.
  const isMobile = hooks.useBreakpoints() === 'mobile'
  const titleSize = variant === 'modal' && !isMobile ? 'small' : 'tiny'

  return (
    <Button
      tag='button'
      role='secondary'
      color={PATH_COLORS[color].fill}
      isSelected={selected}
      isStretch
      className={cx('option', `option-${color}`, {
        'option-selected': selected,
        'option-modal': variant === 'modal',
      })}
      onClick={onClick}
      elmId={elmId}
    >
      {selected ? (
        <Icon
          name='check'
          iconStyle='solid'
          color={PATH_COLORS[color].dark}
          fitted
          style={{ fontSize: '20px' }}
          data-elm-id={`${elmId}_check`}
        />
      ) : (
        <span className={cx('badge')}>
          <Icon
            name={iconName}
            iconStyle='regular'
            color={PATH_COLORS[color].fill}
            fitted
          />
        </span>
      )}
      <span className={cx('text')}>
        <Text
          as='span'
          size={titleSize}
          weight='heavy'
          color={ColorNames.GrayDark}
        >
          {title}
        </Text>
        <Text
          as='span'
          size='mini'
          weight='medium'
          color={ColorNames.GrayMedium}
        >
          {subtitle}
        </Text>
      </span>
    </Button>
  )
}

export default PathOptionButton
